import { Grid } from "@mui/material";
import Capacitaciones from "Components/Clientes/Sondeos/Capacitaciones";
import Degustaciones from "Components/Clientes/Sondeos/Degustaciones";
import Ejecuciones from "Components/Clientes/Sondeos/Ejecuciones";
import Incidencias from "Components/Clientes/Sondeos/Incidencias";
import MenuClientes from "Components/Clientes/Sondeos/Menu";
import Ventas from "Components/Clientes/Sondeos/Ventas";
import Layout from "Layout";
import React, { CSSProperties } from "react";
import { useSelector } from "react-redux";
import { ClientesContainer } from "./styled.components";

const Sondeos = () => {
  const VIEWS: any = {
    1: <Ejecuciones />,
    2: <Degustaciones />,
    3: <Incidencias />,
    4: <Ventas />,
    5: <Capacitaciones />,
  };

  const { catalogs } = useSelector((state: any) => state.theme);
  const { viewSondeo } = useSelector((state: any) => state.common);

  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  const renderView = () => {
    return VIEWS[viewSondeo];
  };

  return (
    <Layout theme={styles}>
      <ClientesContainer container spacing={3}>
        <Grid item xs={3}>
          <MenuClientes />
        </Grid>
        <Grid item xs={9}>
          {renderView()}
        </Grid>
      </ClientesContainer>
    </Layout>
  );
};

export default Sondeos;
